import React from 'react';
import bgBridge from '../../static/images/section0-accueil/photo-dei-expo.jpg';
import diags from '../../static/images/effects/diags.svg';

export const Section0Accueil = () => (
  <section id="section0-accueil" className="mb-12 md:mb-24">
    <div className="intro-content">
      <div className="intro-photo-left">
        <div className="img-container">
          <img src={bgBridge} alt="enfants jouants à la marelle" />
        </div>
        <p className="text-on-img">
          Défense des Enfants International - Belgique est fière de vous dévoiler les œuvres de sensibilisation à la violence basée sur le genre (VBG) réalisées, dans le cadre du projet BRIDGE, par des enfants avec un parcours migratoire et résidant dans des centres d’accueil en Belgique francophone.
          <br />
          <span className="hidden md:inline">Ces outils ont vocation à être diffusés dans le réseau d’accueil pour qu’un maximum d’enfants migrant·e·s puissent être mieux protégé·e·s face à la VBG.</span>
        </p>
        <img src={diags} className="diags" alt="trais gris décoratifs en diagonales" aria-hidden="true" />

      </div>
      <div className="intro-text-right p-2 text-xl">
        <div className="intro-text-right__content">
          <h2 className="text-3xl">Bridge</h2>
          <p className="mt-4">Par cette exposition, DEI - Belgique et ses partenaires font résonner la voix des enfants et mettent en lumière leur incroyable talent et leur créativité pour lutter contre la VBG.</p>
          <p className="mt-4 text-right">
            Bonne visite !
          </p>
        </div>
      </div>
    </div>
  </section>
);
